<template>
    <div class="dingdan">
        <Breadtabsheader/>

        <!--查询-->
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="物料编码" prop="MATNR">
                            <el-input v-model="formInline.MATNR" placeholder="请输入"
                                      style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="工厂编码" prop="WERKS">
                            <el-input v-model="formInline.WERKS" placeholder="请输入"
                                      style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="库位编码" prop="LGORT">
                            <el-input v-model="formInline.LGORT" placeholder="请输入"
                                      style="width: 100%"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                    </div>
                </div>
            </div>
        </div>
        <!--查询end-->

        <!--列表-->
        <div class="h-table h-mrt30">
            <el-table
                ref="ddtable"
                :data="tableData"
                border
                :show-overflow-tooltip="true"
                style="width: 100%"
                max-height="450"
            >
                <el-table-column
                    fixed
                    prop="matnr"
                    label="物料编码"
                    :show-overflow-tooltip="true"
                    width="150">
                </el-table-column>
                <el-table-column
                    prop="matnrName"
                    label="物料名称"
                    :show-overflow-tooltip="true"
                    width="200">
                </el-table-column>

                <el-table-column
                    prop="labst"
                    label="库存数量"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="cpdlcode"
                    label="产品大类编码"
                   >
                </el-table-column>
                <el-table-column
                    prop="cpdlname"
                    label="产品大类"
                  >
                </el-table-column>

                <el-table-column
                    prop="value"
                    label="一级价"
                   >
                </el-table-column>

                <el-table-column
                    prop="halfValue"
                    label="五折价"
                    >
                </el-table-column>

                <el-table-column
                    prop="werks"
                    label="工厂"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="lgort"
                    label="库位"
                    width="100">
                </el-table-column>

                <el-table-column
                    prop="isOccupied"
                    label="是否占用"
                    width="120">
                    <template slot-scope="scope">
                        <span :style="{ color: scope.row.isOccupied === '已占用' ? '#F56C6C' : '' }">
                            {{ scope.row.isOccupied }}
                        </span>
                    </template>
                </el-table-column>

            </el-table>
            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                <pagination :page="formInline" @query="query"/>
                <div style="display:flex;align-items: center;">
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                               @click="exportExcel">导出
                    </el-button>
                </div>
            </div>
        </div>
        <!--列表end-->
    </div>
</template>
<script>
import ss from '@/api/SystemService'
import updownfile from "@/utils/updownfile";
export default {
    data(){
        return{
            formInline: {
                pageSize: 10,
                pageNo: 1,
                total: 0,
                MATNR: null,  //物料编码
                WERKS: null,//工厂
                LGORT: null,  //库位
                updateFlag: true, //是否更新

            },
            tableData: []
        }
    },
    created() {
        this.query()
    },
    methods:{
        // 展开折叠
        collapseChange(){
            this.isScreen = !this.isScreen;
        },
        //检索
        handleFilter(){
            this.formInline.pageNo = 1;
            this.query();
        },
        //重置
        resetData(){
            this.formInline = {
                pageNo: 1,
                pageSize: 10,
                total: 0,
                updateFlag: true,
            }
            this.query()
        },
        query(){
            ss.OrderService.selectSapKucunPage(this.formInline).then(rd => {
                this.tableData = rd.records;
                this.formInline.total = rd.total || 0;
                this.formInline.updateFlag = false;  // 首次查询后置为false，后续所有请求均为false
            })
        },



        //导出
        exportExcel(){
            updownfile.down("/api/swyl/v1/sapkucun/downloadExcel", this.formInline, "get");
        }
    }
}
</script>
<style scoped>
.xiangmu .h-piece, .h-mrt30 {
    margin: 20px;
}

.h-formBtnOut .h-mr20 {
    margin-left: 1rem !important;
}

.D-date .el-cascader {
    line-height: 0;
}
.tableclslist	.h-tableLink{
    padding:0px 2px!important;
}
.h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__label{
    width: 20%;
}
.h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__content{
    width: 80%;
}
</style>
